export const DIRECTION = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
};

export default {
  DIRECTION,

  NOTIFICATION_TYPES: {
    WARNING: 1,
    ERROR: 2,
  },

  QUEUE: 'queue',
  CROP: 'crop',
  ABOUT: 'about',
  METADATA: 'metadata',

  OAUTH_STORAGE_TOKEN: 'CLD_UW_SERVICE_OAUTH_TOKEN',

  MAX_INLINE_MENU_SOURCES: 8,

  TAB_HEADER_HEIGHT: 51,
};

export const CLOSE_PROMPT_WIDTH = 70;

export const THUMBNAIL_WIDTH_WHEN_PANEL_OPENED = 174;
export const THUMBNAIL_WIDTH_WHEN_PANEL_CLOSED = 198;

export const MOBILE_FOOTER_HEIGHT = 57;
export const MOBILE_FOOTER_ADVANCED_OPTION_HEIGHT = 30;
